import $ from '../jQuery/jQuery';

$(document).ready(() => {
    const $catalogBreadcrumb = $('#dinamic-category-breadcrumb-content');

    if (!$catalogBreadcrumb.length) {
        // not an online catalog page
        return;
    }

    // eslint-disable-next-line no-undef
    let $globalConfig;
    if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
        $globalConfig = config;
    }

    if (!$globalConfig.survey || !$globalConfig.survey.id) {
        // survey config not available
        return;
    }

    const storageKey = 'ks-catalog-survey';
    let storageValue;

    try {
        // read and parse object from localstorage
        storageValue = JSON.parse(localStorage.getItem(storageKey));
    } catch (error) {
        storageValue = null;
    }

    if (!storageValue || typeof storageValue.visitedPages !== 'number') {
        // object could not be read from localstorage or is invalid
        // so set default value
        storageValue = {
            visitedPages: 0,
            lastUpdate: -1,
            surveyId: null,
        };
    }

    if (storageValue.surveyId && storageValue.surveyId !== $globalConfig.survey.id) {
        // a new surveyId was configured in the global config
        // so reset the visited pages counter
        // and the surveyId so
        // the user can participate in it
        storageValue.visitedPages = 0;
        storageValue.surveyId = null;
    }

    storageValue.visitedPages++; // increment visited pages counter
    storageValue.lastUpdate = Date.now(); // update lastUpdate timestamp

    if (
        (!storageValue.surveyId || storageValue.surveyId !== $globalConfig.survey.id)
        && storageValue.visitedPages >= +$globalConfig.survey.visitedPages
    ) {
        // the user did not already start the configured survey
        // and reached the limit of visited pages count
        // so start the survey with the configured timeout

        window.ks.survey.ready(() => {
            setTimeout(() => {
                const surveyStarted = window.ks.survey.startSurveyById($globalConfig.survey.id);

                if (!surveyStarted) {
                    // survey was not started
                    return;
                }

                // save the ID of the started survey
                storageValue.surveyId = $globalConfig.survey.id;

                // save storage value with started surveyId
                localStorage.setItem(storageKey, JSON.stringify(storageValue));
            }, +$globalConfig.survey.timeout || 0);
        });
    }

    // save storage value with incremented visitedPages and lastUpdate
    localStorage.setItem(storageKey, JSON.stringify(storageValue));
});
